import ComingSoonPage from "../../components/ComingSoonPage";
import AppShell from '../../components/AppShell';

export default function PitchCraft() {
  return (
    <AppShell>
      <div className="lg:col-span-8 space-y-6 text-center">
    <ComingSoonPage
      appName="Pitch Craft AI"
      teaser="Craft stunning pitch decks and investor-ready models in minutes."
      imageSrc="/images/coming-soon/pitchcraft.png"
    />
    </div>
    </AppShell>
  );
}
